<template>
  <div class="container">
      <top-bar></top-bar>
      <div class="s-home-cart">
        <h4 class="s-title">
          今日热门
        </h4>
        <div class="s-figure">
          <img :src="list[0] && list[0].selfy && list[0].selfy[list[0].selfyIndex || 0]" alt="">
          <p class="text">
            {{list[0] && list[0].douyinName}} <small>粉丝数 {{ list[0] && numberFormat(list[0].douyinFansCount) }}</small>
          </p>
        </div>
        <div class="s-figure-list-contianer">
          <ul class="s-figure-list">
            <li v-for="(item,index) in list.slice(1)" :key="index">
              <router-link :to="{ name: 'infoDetail', params: { id: item.id }}" class="s-figure-info">
                <div class="figure-img" :style="{backgroundImage:'url('+item.selfy[item.selfyIndex || 0]+')'}"></div>
                <h4 class="nickname">{{item.douyinName}}</h4>
                <p>粉丝数 {{numberFormat(item.douyinFansCount)}}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="s-fixed-button-wrap" style="position: static" v-if="!token">
        <router-link class="s-button s-button-primary s-button-block container" :to="{name:'infoAdd'}">我也要上传</router-link>
      </div>
      <div class="s-home-cart">
        <h4 class="s-title">
          活动列表
        </h4>
        <div>
          <ul class="task-list">
            <li  v-for="item in taskList" :key="item.id">
              <router-link :to="{ name: 'taskDetail', params: { id: item.id }}" class="task-item">
                <p><strong class="brand-name">{{item.brandName}}</strong><span class="time">{{item.submitEndTime}}</span></p>
                <p class="content">{{item.content}}</p>
                <p class="require">报名要求：粉丝数{{item.requiredFansCount}}~{{item.maxFansCount}}万、需要{{item.requiredSubmitCount}}名达人</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
import config from '@/utils/config'
import utils from '@/utils/index'
import auth from '@/utils/auth'
import TopBar from '@/components/topBar'
import jskit from '@/assets/js/jskit'

export default {
  name: 'home',
  data() {
    return {
      list: [],
      numberFormat: utils.numberFormat,
      taskList: [],
      token:auth.getToken()
    }
  },
  methods: {
    getInfo() {
      this.$http.get(`${config.HOST}douyin/v1/kol/searchKol?pageSize=4`).then(
        response => {
          let data = response.body
          if (data.code === 0) {
            this.list = data.data
          } else {
          }
        },
        response => {}
      )
    },
    getTaskList(){
      this.$http.get(`${config.HOST}douyin/v1/task/search?pageSize=100`).then(
        response => {
          let data = response.body
          if (data.code === 0) {
            this.taskList = data.data.list
          } else {
          }
        },
        response => {}
      )
    }
  },
  mounted() {
    this.getInfo()
    this.getTaskList()
    jskit.openShare && jskit.openShare({
      title: "抖音资源",
      desc: "你需要的都在这里",
      imgUrl: "http://static.xiawan8.com/favicon.png",
    });
  },
  components: {
    'top-bar': TopBar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import './index.less';
.task-list{

}
.task-item{
  padding: 15px;
  border-bottom: 1px solid #0e0f1a;
  display: block;
  .time,
  &>.require{
    font-size: 14px;
    color:#9a9a9c;
  }
  .brand-name{
    color: #FE2B55;
    font-weight: 100;
    font-size: 12px;
    margin-right: 5px;
  }
  &>.content{
    color:#fff;
    font-size: 16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Index.vue